import { FC } from 'react';

import './rdp-base.css';

import { DateRangePickerProps } from '../model/DateRangePickerProps';

import RangeDatePicker from './RangeDatePicker/RangeDatePicker';
import SingleDatePicker from './SingleDatePicker/SingleDatePicker';

export type {
  DateRangePickerProps,
  DateRangePickerRangeProps,
  DateRangePickerSingleProps,
} from '../model/DateRangePickerProps';

/** Выбор даты/диапазона дат на react-day-picker: `mode="range"` (по умолчанию) или `mode="single"`. */
const DateRangePicker: FC<DateRangePickerProps> = (props) =>
  // eslint-disable-next-line react/destructuring-assignment -- mode is the discriminant of a union prop type, can't destructure without losing type narrowing
  props.mode === 'single' ? <SingleDatePicker {...props} /> : <RangeDatePicker {...props} />;

export default DateRangePicker;
